export default function traduzirProdutoAtividade(
  obj: {
    id: number;
    codSAP?: string;
    codSGE?: string;
    significado?: string;
    produtoId: number;
  },
  limitado = false,
): string {
  if (limitado)
    return `${obj.codSAP || ''} ${obj.codSGE ? `(${obj.codSGE})` : ''}`;

  return `${obj.codSAP || ''} - ${obj.significado ?? ''} ${
    obj.codSGE ? `(${obj.codSGE})` : ''
  }`;
}
